<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <manual-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import ManualProvider from "../../../../providers/ManualProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import ManualForm from "../ManualForm";
  
    

    export default {
        name: "ManualUpdate",
        
        components: { ManualForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.manual.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    nombre: this.item.nombre,
                    link: this.item.link
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ManualProvider.updateManual(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateManual)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

